import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE,
  FETCH_RENTAL_ESTIMATE,
  FETCH_RENTAL_ESTIMATE_SUCCESS,
  FETCH_RENTAL_ESTIMATE_FAILED,
  CLEAR_RENTAL_ESTIMATE,
  FETCH_DRIVER_ESTIMATE,
  FETCH_DRIVER_ESTIMATE_SUCCESS,
  FETCH_DRIVER_ESTIMATE_FAILED,
  CLEAR_DRIVER_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { NewFareCalculator } from '../other/FareCalculator';
import { getRouteDetails } from '../other/GoogleAPIFunctions';
import { store } from '../store/store';
import {
  cloud_function_server_url,
} from '../../config';

const FARE_END_POINT = `${cloud_function_server_url}/fare`;

// export const getEstimate = (bookingData) => (dispatch) => (firebase) => {

//   const { fareListRef } = firebase;

//   dispatch({
//     type: FETCH_ESTIMATE,
//     payload: bookingData,
//   });

//   let startLoc = '"' + bookingData.pickup.coords.lat + ',' + bookingData.pickup.coords.lng + '"';
//   let destLoc = '"' + bookingData.drop.coords.lat + ',' + bookingData.drop.coords.lng + '"';
//   let settings = store.getState().settingsdata.settings;

//   getRouteDetails(startLoc, destLoc).then((res) => {
//     if (res) {
//       let points = Polyline.decode(res.polylinePoints);
//       let waypoints = points.map((point) => {
//         return {
//           latitude: point[0],
//           longitude: point[1]
//         }
//       });

//       let coordinates = JSON.parse(settings.centerAddress);
//       let returnStartLocation = '"' + bookingData.drop.coords.lat + ',' + bookingData.drop.coords.lng + '"';
//       let returnDestLocation = '"' + coordinates.coords.lat + ',' + coordinates.coords.lng + '"';

//       getRouteDetails(returnStartLocation, returnDestLocation).then((returnResponse) => {

//         let returndistance = settings.convert_to_mile ? (returnResponse.distance / 1.609344) : returnResponse.distance;
//         let distanceCityLimit = returndistance - settings.cityLimit;

//         let distance = settings.convert_to_mile ? (res.distance / 1.609344) : res.distance;
//         var totalCost = 0;
//         var grandTotal = 0;
//         var gstcommission = 0;
//         var earningCommissionFee = 0;
//         var estimateArray = [];


//         fareListRef.on("value", (snapshot) => {
//           if (snapshot.val()) {
//             const data = snapshot.val();
//             const fare = Object.keys(data)
//               .map((i) => {
//                 data[i].id = i;
//                 return data[i];
//               });

//             if (bookingData.bookType === 'local') {
//               if (distance <= 1) {
//                 bookingData.carDetails.map(item => {
//                   //minimum fare
//                   totalCost = getBaseFare(fare, 0, 0, 'min', bookingData.bookType, item.name.toLowerCase());
//                   // commission fees for ride earning
//                   if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
//                     earningCommissionFee = item.convenience_fees;
//                   } else {
//                     earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
//                   }
//                   // gst commission for 
//                   gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
//                   // grand total
//                   grandTotal = totalCost + earningCommissionFee + gstcommission;

//                   let fareObject = {
//                     pickup: bookingData.pickup,
//                     drop: bookingData.drop,
//                     bookLater: bookingData.bookLater,
//                     bookingDate: bookingData.bookingDate,
//                     carDetails: item,
//                     estimateDistance: parseFloat(distance).toFixed(2),
//                     fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
//                     estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
//                     estimateTime: res.duration,
//                     convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
//                     waypoints: waypoints,
//                     bookType: bookingData.bookType
//                   };
//                   estimateArray.push(fareObject);
//                 });

//               } else if (distance > 1 && distance <= 8) {
//                 bookingData.carDetails.map(item => {
//                   // base fee
//                   let baseCost = getBaseFare(fare, 0, 0, 'base', bookingData.bookType, item.name.toLowerCase());
//                   // km based fee calculation
//                   let distanceCost = getFare(fare, 0, 8, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

//                   var minutes = Math.floor(res.duration / 60);

//                   totalCost = baseCost + distanceCost + (minutes * 1);

//                   // commission fees for ride earning
//                   if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
//                     earningCommissionFee = item.convenience_fees;
//                   } else {
//                     earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
//                   }
//                   // gst commission for 
//                   gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
//                   // grand total
//                   grandTotal = totalCost + earningCommissionFee + gstcommission;

//                   let fareObject = {
//                     pickup: bookingData.pickup,
//                     drop: bookingData.drop,
//                     bookLater: bookingData.bookLater,
//                     bookingDate: bookingData.bookingDate,
//                     carDetails: item,
//                     estimateDistance: parseFloat(distance).toFixed(2),
//                     fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
//                     estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
//                     estimateTime: res.duration,
//                     convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
//                     waypoints: waypoints,
//                     bookType: bookingData.bookType
//                   };
//                   estimateArray.push(fareObject);
//                 });

//               } else if (distance > 8 && distance <= 15) {
//                 bookingData.carDetails.map(item => {
//                   // base fee
//                   let baseCost = getBaseFare(fare, 0, 0, 'base', bookingData.bookType, item.name.toLowerCase());
//                   // km based fee calculation
//                   let distanceCost1 = getFare(fare, 0, 8, 'km', bookingData.bookType, item.name.toLowerCase(), distance);
//                   //less distance by sub old values
//                   let distanceCost2 = getFare(fare, 8, 15, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

//                   var minutes = Math.floor(res.duration / 60);

//                   totalCost = baseCost + distanceCost1 + distanceCost2 + (minutes * 1);
//                   // commission fees for ride earning
//                   if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
//                     earningCommissionFee = item.convenience_fees;
//                   } else {
//                     earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
//                   }
//                   // gst commission
//                   gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
//                   // grand total
//                   grandTotal = totalCost + earningCommissionFee + gstcommission;

//                   let fareObject = {
//                     pickup: bookingData.pickup,
//                     drop: bookingData.drop,
//                     bookLater: bookingData.bookLater,
//                     bookingDate: bookingData.bookingDate,
//                     carDetails: item,
//                     estimateDistance: parseFloat(distance).toFixed(2),
//                     fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
//                     estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
//                     estimateTime: res.duration,
//                     convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
//                     waypoints: waypoints,
//                     bookType: bookingData.bookType
//                   };
//                   estimateArray.push(fareObject);
//                 });
//               } else {
//                 bookingData.carDetails.map(item => {
//                   // base fee
//                   let baseCost = getBaseFare(fare, 0, 0, 'base', bookingData.bookType, item.name.toLowerCase());
//                   // km based fee calculation
//                   let distanceCost1 = getFare(fare, 0, 8, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

//                   let distanceCost2 = getFare(fare, 8, 15, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

//                   let distanceCost3 = getFare2(fare, 15, 15, distance, 'km', bookingData.bookType, item.name.toLowerCase());

//                   var minutes = Math.floor(res.duration / 60);

//                   totalCost = baseCost + distanceCost1 + distanceCost2 + distanceCost3 + minutes * 1;

//                   // commission fees for ride earning
//                   if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
//                     earningCommissionFee = item.convenience_fees;
//                   } else {
//                     earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
//                   }
//                   // gst commission
//                   gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
//                   // grand total
//                   grandTotal = totalCost + earningCommissionFee + gstcommission;

//                   let fareObject = {
//                     pickup: bookingData.pickup,
//                     drop: bookingData.drop,
//                     bookLater: bookingData.bookLater,
//                     bookingDate: bookingData.bookingDate,
//                     carDetails: item,
//                     estimateDistance: parseFloat(distance).toFixed(2),
//                     fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
//                     estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
//                     estimateTime: res.duration,
//                     convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
//                     waypoints: waypoints,
//                     bookType: bookingData.bookType
//                   };
//                   estimateArray.push(fareObject);
//                 });
//               }
//             } else if (bookingData.bookType === 'outstation') {
//               bookingData.carDetails.map(item => {

//                 distance = distance + distanceCityLimit;

//                 var basefare = getBaseOutstationFare(fare, 'base', bookingData.bookType, item.name.toLowerCase());

//                 var outstationObject = getOutStationFare(fare, 'km', bookingData.bookType, item.name.toLowerCase());

//                 var allowanceObject = getAllowanceFare(fare, 1, 'allowance', bookingData.bookType, item.name.toLowerCase());

//                 var minutes = Math.floor(res.duration / 60);

//                 totalCost = (outstationObject.fare * distance) + allowanceObject.fare + basefare + (minutes * 1) + settings.bookingServiceFee;

//                 // commission fees for ride earning
//                 if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
//                   earningCommissionFee = item.convenience_fees;
//                 } else {
//                   earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
//                 }
//                 // gst commission for 
//                 gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);

//                 // grand total
//                 grandTotal = totalCost + earningCommissionFee + gstcommission;

//                 let fareObject = {
//                   pickup: bookingData.pickup,
//                   drop: bookingData.drop,
//                   bookLater: bookingData.bookLater,
//                   bookingDate: bookingData.bookingDate,
//                   carDetails: item,
//                   carType: bookingData.carType,
//                   carImage: bookingData.carImage,
//                   customer_name: bookingData.customer_name ? bookingData.customer_name : '',
//                   customer_contact: bookingData.customer_contact ? bookingData.customer_contact : '',
//                   estimateDistance: parseFloat(distance).toFixed(2),
//                   fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
//                   estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
//                   estimateTime: res.duration,
//                   convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
//                   waypoints: waypoints,
//                   bookType: bookingData.bookType
//                 };
//                 estimateArray.push(fareObject);
//               });
//             }
//           }
//           dispatch({
//             type: FETCH_ESTIMATE_SUCCESS,
//             payload: estimateArray,
//           });
//         });

//       });
//     } else {
//       dispatch({
//         type: FETCH_ESTIMATE_FAILED,
//         payload: "No Route Found",
//       });
//     }
//   });
// }

export const getEstimate = (bookingData, settings) => (dispatch) => (firebase) => {
  // const { fareListRef } = Firebases;
  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });

  let startLoc = bookingData.pickup.coords.lat + ',' + bookingData.pickup.coords.lng
  let destLoc = bookingData.drop.coords.lat + ',' + bookingData.drop.coords.lng
  // let settings = store.getState().settingsdata.settings;

  const arr = startLoc.split(',').map(element => {
    return Number(element);
  });
  const arr1 = destLoc.split(',').map(element => {
    return Number(element);
  });

  getRouteDetails(arr[0] + ',' + arr[1], arr1[0] + ',' + arr1[1]).then((res) => {
    if (res) {
      let points = Polyline.decode(res.polylinePoints);
      let waypoints = points.map((point) => {
        return {
          latitude: point[0],
          longitude: point[1]
        }
      });

      let coordinates = JSON.parse(settings.centerAddress);
      let returnStartLocation = bookingData.drop.coords.lat + ',' + bookingData.drop.coords.lng
      let returnDestLocation = coordinates.coords.lat + ',' + coordinates.coords.lng

      const returnStart = returnStartLocation.split(',').map(element => {
        return Number(element);
      });
      const returnDest = returnDestLocation.split(',').map(element => {
        return Number(element);
      });

      getRouteDetails(returnStart[0] + ',' + returnStart[1], returnDest[0] + ',' + returnDest[1]).then(async (returnResponse) => {
        let returndistance = settings.convert_to_mile ? (returnResponse.distance / 1.609344) : returnResponse.distance;
        let distanceCityLimit = returndistance - settings.cityLimit;

        let distance = settings.convert_to_mile ? (res.distance / 1.609344) : res.distance;
        var totalCost = 0;
        var grandTotal = 0;
        var gstcommission = 0;
        var earningCommissionFee = 0;
        var estimateArray = [];

        const resp = await fetch(`${FARE_END_POINT}/fetch-fares`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const response = await resp.json();
        const fare = response?.data;

        console.log("bookingData", bookingData)

        if (bookingData.bookType === 'local') {
          if (distance <= 1) {
            bookingData.carDetails.map(item => {
              //minimum fare
              totalCost = getBaseFare(fare, 0, 0, 'min', bookingData.bookType, item.name.toLowerCase());
              // commission fees for ride earning
              if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
                earningCommissionFee = item.convenience_fees;
              } else {
                earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
              }
              // gst commission for 
              gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
              // grand total
              grandTotal = totalCost + earningCommissionFee + gstcommission;

              let fareObject = {
                pickup: bookingData.pickup,
                drop: bookingData.drop,
                bookLater: bookingData.bookLater,
                bookingDate: bookingData.bookingDate,
                carDetails: item,
                estimateDistance: parseFloat(distance).toFixed(2),
                fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
                estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
                estimateTime: res.duration,
                convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
                waypoints: waypoints,
                bookType: bookingData.bookType
              };
              estimateArray.push(fareObject);
            });

          } else if (distance > 1 && distance <= 8) {
            console.log("inside 8")
            bookingData.carDetails.map(item => {
              // base fee
              let baseCost = getBaseFare(fare, 0, 0, 'base', bookingData.bookType, item.name.toLowerCase());

              // km based fee calculation
              let distanceCost = getFare(fare, 0, 8, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

              var minutes = Math.floor(res.duration / 60);

              totalCost = baseCost + distanceCost + (minutes * 1);

              // commission fees for ride earning
              if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
                earningCommissionFee = item.convenience_fees;
              } else {
                earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
              }
              // gst commission for 
              gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
              // grand total
              grandTotal = totalCost + earningCommissionFee + gstcommission;

              let fareObject = {
                pickup: bookingData.pickup,
                drop: bookingData.drop,
                bookLater: bookingData.bookLater,
                bookingDate: bookingData.bookingDate,
                carDetails: item,
                estimateDistance: parseFloat(distance).toFixed(2),
                fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
                estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
                estimateTime: res.duration,
                convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
                waypoints: waypoints,
                bookType: bookingData.bookType
              };
              estimateArray.push(fareObject);
            });

          } else if (distance > 8 && distance <= 15) {
            bookingData.carDetails.map(item => {
              // base fee
              let baseCost = getBaseFare(fare, 0, 0, 'base', bookingData.bookType, item.name.toLowerCase());
              // km based fee calculation
              let distanceCost1 = getFare(fare, 0, 8, 'km', bookingData.bookType, item.name.toLowerCase(), distance);
              //less distance by sub old values
              let distanceCost2 = getFare(fare, 8, 15, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

              var minutes = Math.floor(res.duration / 60);

              totalCost = baseCost + distanceCost1 + distanceCost2 + (minutes * 1);
              // commission fees for ride earning
              if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
                earningCommissionFee = item.convenience_fees;
              } else {
                earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
              }
              // gst commission
              gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
              // grand total
              grandTotal = totalCost + earningCommissionFee + gstcommission;

              let fareObject = {
                pickup: bookingData.pickup,
                drop: bookingData.drop,
                bookLater: bookingData.bookLater,
                bookingDate: bookingData.bookingDate,
                carDetails: item,
                estimateDistance: parseFloat(distance).toFixed(2),
                fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
                estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
                estimateTime: res.duration,
                convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
                waypoints: waypoints,
                bookType: bookingData.bookType
              };
              estimateArray.push(fareObject);
            });
          } else {
            bookingData.carDetails.map(item => {
              // base fee
              let baseCost = getBaseFare(fare, 0, 0, 'base', bookingData.bookType, item.name.toLowerCase());
              // km based fee calculation
              let distanceCost1 = getFare(fare, 0, 8, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

              let distanceCost2 = getFare(fare, 8, 15, 'km', bookingData.bookType, item.name.toLowerCase(), distance);

              let distanceCost3 = getFare2(fare, 15, 15, distance, 'km', bookingData.bookType, item.name.toLowerCase());

              var minutes = Math.floor(res.duration / 60);

              totalCost = baseCost + distanceCost1 + distanceCost2 + distanceCost3 + minutes * 1;

              // commission fees for ride earning
              if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
                earningCommissionFee = item.convenience_fees;
              } else {
                earningCommissionFee = (totalCost * parseFloat(item.convenience_fees) / 100);
              }
              // gst commission
              gstcommission = (totalCost * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);
              // grand total
              grandTotal = totalCost + earningCommissionFee + gstcommission;

              let fareObject = {
                pickup: bookingData.pickup,
                drop: bookingData.drop,
                bookLater: bookingData.bookLater,
                bookingDate: bookingData.bookingDate,
                carDetails: item,
                estimateDistance: parseFloat(distance).toFixed(2),
                fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
                estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
                estimateTime: res.duration,
                convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
                waypoints: waypoints,
                bookType: bookingData.bookType
              };
              estimateArray.push(fareObject);
            });
          }
        } else if (bookingData.bookType === 'outstation') {
          bookingData.carDetails.map((item, index) => {

            if (index === 0) {
              distance = distance + distanceCityLimit;
            }

            var basefare = getBaseOutstationFare(fare, 'base', bookingData.bookType, item.name.toLowerCase());

            var outstationObject = getOutStationFare(fare, 'km', bookingData.bookType, item.name.toLowerCase());

            var allowanceObject = getAllowanceFare(fare, 1, 'allowance', bookingData.bookType, item.name.toLowerCase());

            var nightAllowanceObject = getAllowanceFare(fare, 1, 'night_allowance', bookingData.bookType, item.name.toLowerCase());

            totalCost = (basefare * distance);

            if (bookingData.dropType === 'roundTrip') {
              var start = bookingData.dateTime.startTrip
              var end = bookingData.dateTime.returnTrip
              if (start && end) {
                const startDate = getFromDate(start)
                const startTime = getHoursFromDate(start)
                const startAmpm = getampmFromDate(start)
                const endDate = getFromDate(end)
                const endTime = getHoursFromDate(end)
                const endAmpm = getampmFromDate(end)

                var fareType
                var totalFareAllowance = 0

                var split = start.toString()
                var endSplit = end.toString()
                var getDay1 = getDifferenceInDays(start, end)
                var getDay2 = (endSplit.split(' ')[2] - split.split(' ')[2]) + 1
                if (startDate === endDate || Math.abs(start - end) / 36e5 < 16) {
                  if (startTime >= 6 && endTime <= 22) {
                    if ((startTime >= 6) && (endTime <= 22)) {
                      fareType = 'allowance'
                      totalFareAllowance = totalFareAllowance + allowanceObject.fare
                    } else {
                      fareType = 'night_allowance'
                      totalFareAllowance = totalFareAllowance + nightAllowanceObject.fare
                    }
                  } else {
                    if (startTime >= 6 && startTime <= 22) {
                      fareType = 'allowance'
                      totalFareAllowance = totalFareAllowance + allowanceObject.fare
                    }
                    if (24 > 22 && 6 > 1) {
                      fareType = 'night_allowance'
                      totalFareAllowance = totalFareAllowance + nightAllowanceObject.fare
                    }
                    if (endTime >= 6 && endTime <= 22) {
                      fareType = 'allowance'
                      totalFareAllowance = totalFareAllowance + allowanceObject.fare
                    }
                  }
                } else {
                  var getDay = getDifferenceInDays(start, end)
                  if (getDay === 0) {
                    getDay = (endSplit.split(' ')[2] - split.split(' ')[2])
                  }
                  for (var i = 1; i <= getDay; i++) {
                    if (startTime >= 6 && startTime <= 22) {
                      fareType = 'allowance'
                      totalFareAllowance = totalFareAllowance + allowanceObject.fare
                    }
                    if (24 > 22 && 6 > 1 && (Math.abs(start - end) / 36e5) >= 16) {
                      fareType = 'night_allowance'
                      totalFareAllowance = totalFareAllowance + nightAllowanceObject.fare
                    }
                    if (endTime >= 6 && endTime <= 22 && (Math.abs(start - end) / 36e5) >= 16) {
                      fareType = 'allowance'
                      totalFareAllowance = totalFareAllowance + allowanceObject.fare
                    }
                  }
                }

                // if (startDate === endDate) {
                //   if ((startTime >= 6 && startAmpm === 'am') && (endTime <= 22 && endAmpm === 'pm')) {
                //     fareType = 'allowance'
                //     totalFareAllowance = totalFareAllowance + allowanceObject.fare
                //   } else {
                //     fareType = 'night_allowance'
                //     totalFareAllowance = totalFareAllowance + nightAllowanceObject.fare
                //   }
                // } else {
                //   var split = start.toString()
                //   var endSplit = end.toString()
                //   // var getDay = getDifferenceInDays(start, end)
                //   var getDay = (endSplit.split(' ')[2] - split.split(' ')[2]) + 1
                //   console.log(getDay, getDay - 1, getDay + (getDay - 1))

                //   if (getDay >= 2) {
                //     getDay = getDay + (getDay - 1)
                //   }
                //   for (var i = 1; i <= getDay; i++) {
                //     if ((startTime >= 6 && startAmpm === 'am') && (endTime <= 22 && endAmpm === 'pm')) {
                //       fareType = 'allowance'
                //       totalFareAllowance = totalFareAllowance + allowanceObject.fare
                //     } else {
                //       fareType = 'night_allowance'
                //       totalFareAllowance = totalFareAllowance + nightAllowanceObject.fare
                //     }
                //   }
                // }
                // console.log(fareType, totalFareAllowance)
              }
            }

            // commission fees for ride earning
            if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
              earningCommissionFee = item.convenience_fees;
            } else {
              earningCommissionFee = (totalCost * (parseFloat(item.convenience_fees) / 100));
            }
            // gst commission for 
            gstcommission = (totalCost * (settings.rideGST / 100)) + (Number(earningCommissionFee) * (settings.commissionGST / 100)) + (Number(bookingData.dropType === 'roundTrip' ? totalFareAllowance : allowanceObject.fare) * (settings.rideGST / 100)) + (Number(settings.bookingServiceFee) * (settings.commissionGST / 100));

            // grand total
            grandTotal = Number(totalCost) + Number(earningCommissionFee) + Number(gstcommission) + Number(bookingData.dropType === 'roundTrip' ? totalFareAllowance : allowanceObject.fare) + Number(settings.bookingServiceFee);
            let fareObject = {
              pickup: bookingData.pickup,
              drop: bookingData.drop,
              bookLater: bookingData.bookLater,
              bookingDate: bookingData.bookingDate,
              carDetails: item,
              carType: bookingData.carType,
              carImage: bookingData.carImage,
              customer_name: bookingData.customer_name ? bookingData.customer_name : '',
              customer_contact: bookingData.customer_contact ? bookingData.customer_contact : '',
              estimateDistance: parseFloat(distance).toFixed(2),
              fareCost: totalCost ? parseFloat(totalCost).toFixed(2) : 0,
              estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
              estimateTime: res.duration,
              convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
              waypoints: waypoints,
              bookType: bookingData.bookType
            };
            estimateArray.push(fareObject);
          });
        }

        const result = moveArrayItemToNewIndex(estimateArray, 0, 1);

        dispatch({
          type: FETCH_ESTIMATE_SUCCESS,
          payload: result.reverse(),
        });
      });
    } else {
      dispatch({
        type: FETCH_ESTIMATE_FAILED,
        payload: "No Route Found",
      });
    }
  });
}

export const getDriverEstimate = (bookingData) => (dispatch) => (firebase) => {

  dispatch({
    type: FETCH_DRIVER_ESTIMATE,
    payload: bookingData,
  });

  let startLoc = '"' + bookingData.pickup.coords.lat + ',' + bookingData.pickup.coords.lng + '"';
  let destLoc = '"' + bookingData.drop.coords.lat + ',' + bookingData.drop.coords.lng + '"';
  var estimateArray = [];
  let settings = store.getState().settingsdata.settings;

  getRouteDetails(startLoc, destLoc).then((res) => {
    if (res) {
      let points = Polyline.decode(res.polylinePoints);
      let waypoints = points.map((point) => {
        return {
          latitude: point[0],
          longitude: point[1]
        }
      });
      let distance = settings.convert_to_mile ? (res.distance / 1.609344) : res.distance;

      let fareObject = {
        estimateDistance: distance,
        pickup: bookingData.pickup,
        drop: bookingData.drop,
        estimateTime: res.duration,
        waypoints: waypoints,
        bookType: bookingData.bookType
      };
      estimateArray.push(fareObject);
      dispatch({
        type: FETCH_DRIVER_ESTIMATE_SUCCESS,
        payload: estimateArray,
      });

    } else {
      dispatch({
        type: FETCH_DRIVER_ESTIMATE_FAILED,
        payload: "No Route Found",
      });
    }
  });
}


export const getRentalEstimate = (bookingData) => (dispatch) => (firebase) => {

  const { fareListRef } = firebase;

  dispatch({
    type: FETCH_RENTAL_ESTIMATE,
    payload: bookingData,
  });

  fareListRef.on("value", (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const fare = Object.keys(data)
        .map((i) => {
          data[i].id = i;
          return data[i];
        });

      var estimateArray = [];
      var earningCommissionFee = 0;
      var gstcommission = 0;
      var grandTotal = 0;
      let settings = store.getState().settingsdata.settings;

      bookingData.carDetails.map(item => {
        const rideFareArray = fare.filter(fareitem => fareitem.tripHours === bookingData.tripHour && fareitem.carType === item.name.toLowerCase());

        if (item.convenience_fee_type && item.convenience_fee_type == 'flat') {
          earningCommissionFee = item.convenience_fees;
        } else {
          earningCommissionFee = (rideFareArray[0].fare * parseFloat(item.convenience_fees) / 100);
        }

        gstcommission = (rideFareArray[0].fare * settings.rideGST / 100) + (earningCommissionFee * settings.commissionGST / 100);

        grandTotal = rideFareArray[0].fare + earningCommissionFee + gstcommission;

        let fareObject = {
          pickup: bookingData.pickup,
          bookLater: bookingData.bookLater,
          bookingDate: bookingData.bookingDate,
          carDetails: item,
          estimateDistance: rideFareArray[0].tripKM,
          fareCost: rideFareArray[0].fare ? parseFloat(rideFareArray[0].fare).toFixed(2) : 0,
          estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(2) : 0,
          estimateTime: bookingData.tripHour,
          convenience_fees: earningCommissionFee ? parseFloat(earningCommissionFee).toFixed(2) : 0,
          bookType: bookingData.bookType
        };
        estimateArray.push(fareObject);
      });

      dispatch({
        type: FETCH_RENTAL_ESTIMATE_SUCCESS,
        payload: estimateArray,
      });
    } else {
      dispatch({
        type: FETCH_RENTAL_ESTIMATE_FAILED,
        payload: "No Fare Found",
      });
    }
  });

}

const getBaseFare = (fare, startRange, endRange, fareType, tripType, carname) => {
  var result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === endRange && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
  return result.length > 0 ? result[0].fare : 0;
}

const getBaseOutstationFare = (fare, fareType, tripType, carname) => {
  var result = fare.filter(item => item.tripType === tripType && item.fareType === fareType && item.carType === carname);
  return result.length > 0 ? result[0].fare : 0;
}

const getOutStationFare = (fare, fareType, tripType, carname) => {
  var result = fare.filter(item => item.tripType === tripType && item.fareType === fareType && item.carType === carname);
  return result.length > 0 ? result[0] : [];
}

const getAllowanceFare = (fare, tripDay, fareType, tripType, carname) => {
  var result = fare.filter(item => item.dayTrip === tripDay && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
  return result.length > 0 ? result[0] : [];
}

const getFare = (fare, startRange, endRange, fareType, tripType, carname, distance) => {
  var result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === endRange && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
  let value = 0;
  if (result.length > 0) {
    value = result[0].fare * (endRange > distance ? distance - startRange : endRange - startRange);
  }
  return value;
}

const getFare2 = (fare, startRange, filterEndRange, endRange, fareType, tripType, bookingData) => {
  var result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === filterEndRange && item.tripType === tripType && item.fareType === fareType && item.carType === bookingData.carDetails.name.toLowerCase());
  let value = 0;
  if (result.length > 0) {
    value = result[0].fare * (endRange - startRange);
  }
  return value;
}

export const clearEstimate = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_ESTIMATE,
    payload: null,
  });
}

export const clearDriverEstimate = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_DRIVER_ESTIMATE,
    payload: null,
  });
}

export const clearRentalEstimate = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_RENTAL_ESTIMATE,
    payload: null,
  });
}

const getHoursFromDate = (date) => {
  var hours = date.getHours();
  return hours
}

const getampmFromDate = (date) => {
  var hours = date.getHours();
  var ampm = hours >= 12 ? 'pm' : 'am';
  return ampm;
}

const getFromDate = (date) => {
  var date1 = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  return date1 + '/' + month + '/' + year
}

const getDifferenceInDays = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1)
  return Math.round(diffInMs / (1000 * 60 * 60 * 24))
}

function moveArrayItemToNewIndex(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};